var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPauseCircle = function SvgPauseCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M10.75,21.5a10.751,10.751,0,1,1,7.6-3.149A10.762,10.762,0,0,1,10.75,21.5ZM12.877,7A.878.878,0,0,0,12,7.876v6.249a.879.879,0,0,0,.877.878h.848a.878.878,0,0,0,.877-.878V7.876A.878.878,0,0,0,13.725,7Zm-5,0A.878.878,0,0,0,7,7.876v6.249A.878.878,0,0,0,7.875,15h.851a.877.877,0,0,0,.873-.878V7.876A.876.876,0,0,0,8.726,7Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPauseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pause - Circle.14a7fedbd1d9055ce46538993a25ea29.svg";